<template>
  <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
    <v-card-title>
      <v-container>
        <v-row align="center">
          <v-col cols="8">
            <div class="text-h5 font-weight-bold">Datos generales</div>
          </v-col>
          <v-col cols="4" align="right">
            <TextButton rounded color="secondary" @click="triggerUpdatePersonal"
              >Guardar cambios<v-icon small class="ml-4">mdi-pencil</v-icon></TextButton
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
              <v-tab class="font-weight-bold">Información principal</v-tab>
              <v-tab class="font-weight-bold">Nacionalidad</v-tab>
              <v-tab class="font-weight-bold">Documentación oficial</v-tab>
              <v-tab class="font-weight-bold">Información personal</v-tab>
              <v-tab class="font-weight-bold">Domicilio</v-tab>
              <v-tab class="font-weight-bold">Estudios</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1" eager>
          <InformacionPrincipalTabContent />
        </v-tab-item>
        <v-tab-item key="2" eager>
          <NacionalidadTabContent />
        </v-tab-item>
        <v-tab-item key="3" eager>
          <DocumentacionOficialTabContent />
        </v-tab-item>
        <v-tab-item key="4" eager>
          <InformacionPersonalTabContent />
        </v-tab-item>
        <v-tab-item key="5" eager>
          <DomicilioTabContent />
        </v-tab-item>
        <v-tab-item key="6" eager>
          <EstudiosTabContent />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InformacionPrincipalTabContent from './datos-generales/tab-content/InformacionPrincipalTabContent.vue'
import NacionalidadTabContent from './datos-generales/tab-content/NacionalidadTabContent.vue'
import DocumentacionOficialTabContent from './datos-generales/tab-content/DocumentacionOficialTabContent.vue'
import InformacionPersonalTabContent from './datos-generales/tab-content/InformacionPersonalTabContent.vue'
import DomicilioTabContent from './datos-generales/tab-content/DomicilioTabContent.vue'
import EstudiosTabContent from './datos-generales/tab-content/EstudiosTabContent.vue'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    InformacionPrincipalTabContent,
    NacionalidadTabContent,
    DocumentacionOficialTabContent,
    InformacionPersonalTabContent,
    DomicilioTabContent,
    EstudiosTabContent,
    TextButton,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },
  methods: {
    ...mapActions('personal', ['updatePersonal']),
    async triggerUpdatePersonal() {
      const missingFields = []
      if (!this.personal.apaterno) missingFields.push('Apellido paterno')
      if (!this.personal.amaterno) missingFields.push('Apellido materno')
      if (!this.personal.nombre) missingFields.push('Nombre')

      if (missingFields.length > 0) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', `Faltan campos obligatorios: ${missingFields.join(', ')}`)
        return
      }

      await this.updatePersonal(this.personal)
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para DatosGeneralesComponent */

/* ── Inputs, selects y autocompletes ── */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
}

::v-deep input::placeholder,
::v-deep textarea::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* Chips en combobox */
::v-deep .v-chip {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  color: #e0e0e0 !important;
  border-radius: 8px !important;
}

::v-deep .v-chip .v-chip__close {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

/* Dividers */
::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(16, 16, 30, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Títulos */
::v-deep .text-h6,
::v-deep .text-h5 {
  color: #e0e0e0 !important;
  font-weight: 700;
}

/* Card principal */
.ui-module-card {
  background: rgba(26, 30, 46, 0.7) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ui-module-card:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4);
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
}

/* Card title */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  padding: 24px !important;
}

/* Card text */
::v-deep .v-card-text {
  color: #e0e0e0 !important;
}

/* Títulos */
.text-h5 {
  color: #ffffff !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Tabs */
::v-deep .v-tabs {
  background: transparent !important;
}

::v-deep .v-tab {
  color: rgba(224, 224, 224, 0.7) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  border-radius: 8px 8px 0 0;
  margin: 0 4px;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
  text-align: center;
}

::v-deep .v-tab:hover {
  color: var(--v-secondary-base) !important;
  background: rgba(var(--v-secondary-base-rgb), 0.08);
}

::v-deep .v-tab--active {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  background: rgba(var(--v-secondary-base-rgb), 0.12);
}

::v-deep .v-tabs-slider {
  background: var(--v-secondary-base) !important;
  height: 3px !important;
  border-radius: 3px 3px 0 0;
  box-shadow: 0 2px 8px rgba(var(--v-secondary-base-rgb), 0.5);
}

/* Tab items */
::v-deep .v-tabs-items {
  background: transparent !important;
}

::v-deep .v-window__container {
  background: transparent !important;
}

/* Botones modernos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn.secondary,
::v-deep .v-btn[color='secondary'] {
  background: var(--v-secondary-base) !important;
  color: var(--v-primary-base) !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
  font-weight: 700 !important;
}

::v-deep .v-btn.secondary:hover:not(:disabled),
::v-deep .v-btn[color='secondary']:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn.secondary:active:not(:disabled),
::v-deep .v-btn[color='secondary']:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.5) !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.15) rotate(5deg);
}

/* Container y Grid */
::v-deep .v-container {
  padding: 16px;
}

/* Responsive */
@media (max-width: 960px) {
  ::v-deep .v-tab {
    font-size: 0.75rem !important;
    padding: 0 8px !important;
  }

  .text-h5 {
    font-size: 1.25rem !important;
  }

  ::v-deep .v-btn {
    font-size: 0.875rem !important;
  }
}

@media (max-width: 600px) {
  ::v-deep .v-card-title {
    padding: 16px !important;
  }

  ::v-deep .v-tab {
    font-size: 0.625rem !important;
    min-width: 60px !important;
    padding: 0 4px !important;
  }

  .text-h5 {
    font-size: 1rem !important;
  }
}
</style>
